import { DEFAULT_PIK_REGIONS } from '../../shared/constants/config/pik';
import { isPikRegion } from '../../shared/utils';
import { ISpecialPromoThumbSchema } from '../../shared/repositories/special-promos/entities/schemas/SpecialPromoThumbSchema';

export interface IPromoLink {
  isLegacy: boolean;
  key: string;
  desktopUrl: string;
  mobileUrl: string;
  logoUrl?: string | null;
  logoMobileUrl?: string | null;
  desktopName: string;
  mobileName?: string;
}

const PIK_BUILDER_ID = 9;
export const PIK_KEY = 'pik';

const PIK_LINK = {
  isLegacy: true,
  key: PIK_KEY,
  desktopUrl: '/zastroishchik-pik-9/',
  mobileUrl: getSpecialPromoMobileUrl(PIK_BUILDER_ID, DEFAULT_PIK_REGIONS, PIK_KEY),
  desktopName: 'ПИК',
};

export function createPromoLink(specialPromo: ISpecialPromoThumbSchema, regionId: number): IPromoLink {
  return {
    isLegacy: false,
    key: 'special_promo',
    desktopUrl: `/special-promos/${specialPromo.builderId}/`,
    mobileUrl: getSpecialPromoMobileUrl(specialPromo.builderId, [regionId]),
    desktopName: specialPromo.name,
    mobileName: specialPromo.nameGenitive,
    logoUrl: specialPromo.logoUrl,
    logoMobileUrl: specialPromo.logoMobileUrl,
  };
}

export function getSpecialPromoMobileUrl(builderId: number, regions: number[], legacyKey?: string) {
  const regionsParam = regions.map((region, idx) => `location%5B${idx}%5D=${region}`).join('&');
  // tslint:disable-next-line:max-line-length
  let url = `/cat.php?deal_type=sale&engine_version=2&builder=${builderId}&offer_type=flat&with_newobject=1&object_type%5B0%5D=2&${regionsParam}`;

  if (legacyKey) {
    if (legacyKey === PIK_KEY) {
      url += '&from_developer=1&is_pik_promo=1';
    }
  } else {
    url += '&is_special_promo=1';
  }

  return url;
}

export interface ISpecialPromoLinkData {
  specialPromos: ISpecialPromoThumbSchema[];
  canPreviewSpecialPromos: boolean;
  regionId: number;
  mobileBaseUrl: string;
  pikRegions: number[];
}

export function createSpecialPromoLink(
  specialPromos: ISpecialPromoThumbSchema[],
  canPreviewSpecialPromos: boolean,
  regionId: number,
  pikRegions: number[],
) {
  const isLegacyRegion = isPikRegion(regionId, pikRegions);
  let link: IPromoLink | undefined;

  const regionSpecialPromo = specialPromos.find(specialPromo => specialPromo.region === regionId);

  if (regionSpecialPromo && (!regionSpecialPromo.isPreview || canPreviewSpecialPromos)) {
    link = createPromoLink(regionSpecialPromo, regionId);
  } else if (isLegacyRegion) {
    link = PIK_LINK;
  }

  return link;
}
